(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["page-aboutus"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  // Advisory Board - Read More functionality
  const readMoreBtns = document.querySelectorAll('.read-more-btn');
  const closeDescBtns = document.querySelectorAll('.close-description-btn');
  
  readMoreBtns.forEach(btn => {
    btn.addEventListener('click', function() {
      const card = this.closest('.advisory-card');
      const mobileDesc = card.querySelector('.mobile-description');
      
      // Close all other descriptions
      document.querySelectorAll('.mobile-description').forEach(desc => {
        if (desc !== mobileDesc) {
          desc.classList.remove('active');
        }
      });
      
      // Show current description
      mobileDesc.classList.add('active');
      this.style.display = 'none';
    });
  });
  
  closeDescBtns.forEach(btn => {
    btn.addEventListener('click', function() {
      const card = this.closest('.advisory-card');
      const mobileDesc = card.querySelector('.mobile-description');
      const readMoreBtn = card.querySelector('.read-more-btn');
      
      mobileDesc.classList.remove('active');
      readMoreBtn.style.display = 'inline-block';
    });
  });
  
  // What Makes Us Different - Hover expand functionality
  document.querySelectorAll('.different-card').forEach(card => {
    card.addEventListener('mouseenter', function () {
      // Remove "featured-card" from all cards
      document.querySelectorAll('.different-card').forEach(c => {
        c.classList.remove('featured-card');
      });
      
      // Add "featured-card" to the hovered card
      this.classList.add('featured-card');
    });
  });

  // Set first card as featured by default
  const firstCard = document.querySelector('.different-card');
  if (firstCard) {
    firstCard.classList.add('featured-card');
  }
});

  } catch(e) { console.error(e); }
})();
})();
